import type { IdentityScope } from '@branditdev/mf-types'
import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import { identityScopeQueryOptions } from './queries'

export const useIdentityScope = () => {
  return useQuery(identityScopeQueryOptions())
}

export const useIdentityScopedQuery = <T>(optionsFn: (scope: IdentityScope) => UseQueryOptions<T>) => {
  const { data: identityScope } = useIdentityScope()

  return useQuery({
    ...(identityScope ? optionsFn(identityScope) : { queryKey: ['pending'], queryFn: () => null as T }),
    enabled: identityScope !== undefined
  })
}
